const BankDefault = ({ className = '' }: { className?: string }) => (
  <svg
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9999 4.71631L31.1745 11.9025C31.56 12.1127 31.7999 12.5168 31.7999 12.9559V15.5998C31.7999 16.2625 31.2626 16.7998 30.5999 16.7998H5.3999C4.73716 16.7998 4.1999 16.2625 4.1999 15.5998V12.9559C4.1999 12.5168 4.43977 12.1127 4.82528 11.9025L17.9999 4.71631ZM17.9999 6.08321L5.3999 12.9559V15.5998H30.5999V12.9559L17.9999 6.08321ZM20.9999 26.9998V18.5998H22.1999V26.9998H28.1999V18.5998H29.3999V26.9998H30.5999C31.2626 26.9998 31.7999 27.537 31.7999 28.1998V30.5998C31.7999 30.6506 31.7967 30.7006 31.7906 30.7498H33.5999V31.9498H2.3999V30.7498H4.20919C4.20306 30.7006 4.1999 30.6506 4.1999 30.5998V28.1998C4.1999 27.537 4.73716 26.9998 5.3999 26.9998H6.5999V18.5998H7.7999V26.9998H13.7999V18.5998H14.9999V26.9998H20.9999ZM5.3999 30.5998V28.1998H30.5999V30.5998H5.3999Z'
      fill='#442E83'
    />
    <rect x='5.3999' y='28.7998' width='25.2' height='1.2' fill='#0FD08B' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.6001 11.4C15.6001 12.7255 16.6746 13.8 18.0001 13.8C19.3256 13.8 20.4001 12.7255 20.4001 11.4C20.4001 10.0745 19.3256 9 18.0001 9C16.6746 9 15.6001 10.0745 15.6001 11.4ZM19.2001 11.4C19.2001 12.0627 18.6628 12.6 18.0001 12.6C17.3374 12.6 16.8001 12.0627 16.8001 11.4C16.8001 10.7373 17.3374 10.2 18.0001 10.2C18.6628 10.2 19.2001 10.7373 19.2001 11.4Z'
      fill='#0FD08B'
    />
  </svg>
)

export default BankDefault
